import React from 'react';
import styles from './style/modalFooter.module.css';

const ModalFooter = ({ children }:{ children:React.ReactNode }) => (
  <div className={styles.modalFooter}>
    { children }
  </div>
);

export default ModalFooter;
